export const SAMPRADAYA_OPTIONS = [
  { id: 'shaiva',    icon: '🔱', label: 'शैव',      glossaryKey: 'seva.gigs.sampradaya.shaiva'    },
  { id: 'vaishnava', icon: '🪔', label: 'वैष्णव',   glossaryKey: 'seva.gigs.sampradaya.vaishnava' },
  { id: 'smarta',    icon: '✦',  label: 'स्मार्त',  glossaryKey: 'seva.gigs.sampradaya.smarta'    },
  { id: 'shakta',    icon: '🔶', label: 'शाक्त',    glossaryKey: 'seva.gigs.sampradaya.shakta'    },
  { id: 'sikh',      icon: '🌸', label: 'सिख',      glossaryKey: 'seva.gigs.sampradaya.sikh'      },
  { id: 'jain',      icon: '☮️', label: 'जैन',      glossaryKey: 'seva.gigs.sampradaya.jain'      },
  { id: 'bauddha',   icon: '☸️', label: 'बौद्ध',    glossaryKey: 'seva.gigs.sampradaya.bauddha'   },
] as const;

export type SampradayaId = typeof SAMPRADAYA_OPTIONS[number]['id'];
